import { LOCAL_STORAGE_USER } from '../const/LocalStorage.js';

export const loginDetail = getLoginDetail();
export const userDetail = loginDetail !== null ? loginDetail.User : null;
export const pageAccess = loginDetail !== null ? loginDetail.PageAccess : null;
export const pageFunctionMap = loginDetail !== null ? loginDetail.PageFunctionMap : null;
export const pageEnum = loginDetail !== null ? loginDetail.PageEnum : null;

export function getLoginDetail(storageKey = LOCAL_STORAGE_USER){
    return JSON.parse(localStorage.getItem(storageKey));
}

export function getPageFunction({pageId}){
    const resultMap = pageFunctionMap
        .filter(d => d.pageId === pageId)[0];    

    return resultMap;
}